/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Step_2_DescInputs */

const en_mk_tb_step_2_desc = /** @type {(inputs: Mk_Tb_Step_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch current context through the CLI or MCP, then use the coding tool you already know.`)
};

const id_mk_tb_step_2_desc = /** @type {(inputs: Mk_Tb_Step_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambil konteks terbaru melalui CLI atau MCP, lalu gunakan alat coding yang Anda kenal.`)
};

/**
* | output |
* | --- |
* | "Fetch current context through the CLI or MCP, then use the coding tool you already know." |
*
* @param {Mk_Tb_Step_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_step_2_desc = /** @type {((inputs?: Mk_Tb_Step_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Step_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_step_2_desc(inputs)
	return en_mk_tb_step_2_desc(inputs)
});